import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "platform-select" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenuPlatforms && _ctx.openMenuPlatforms(...args)))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "icon-nav-app" }, null, -1)
    ])),
    (_ctx.showPlatforms)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "platform-select__platforms-list",
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveMenuPlatforms && _ctx.mouseLeaveMenuPlatforms(...args)))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("p", null, [
            _createTextVNode(" Plataformas "),
            _createElementVNode("i", { class: "icon-nav-app" })
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, (platform, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: platform.action
            }, _toDisplayString(platform.label), 9, _hoisted_2))
          }), 128))
        ], 32))
      : _createCommentVNode("", true)
  ]))
}